import React from 'react'
import styles from './styles.module.css'
import { createPortal } from 'react-dom'
import { Draggable, DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'

/** Portal the moving preview out of the modal's transformed slide-in panel. Editors stay mounted. */
export const SortableSubtaskCard: React.FC<{
  id: string
  index: number
  disabled: boolean
  status: string
  rtl: boolean
  children: (handleProps?: DraggableProvidedDragHandleProps) => React.ReactNode
}> = ({ id, index, disabled, status, rtl, children }) => (
  <Draggable draggableId={id} index={index} isDragDisabled={disabled} disableInteractiveElementBlocking>
    {(provided, snapshot) => {
      const card = (
        <article
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{ ...provided.draggableProps.style, zIndex: snapshot.isDragging ? 10002 : undefined }}
          className={`${styles.card} ${styles[status]} ${snapshot.isDragging ? styles.dragging : ''}`}
          data-subtask-id={id}
          data-subtask-state={status}
        >
          {children(provided.dragHandleProps || undefined)}
        </article>
      )

      return snapshot.isDragging
        ? createPortal(
            <div className={styles.dragLayer} dir={rtl ? 'rtl' : 'ltr'}>
              {card}
            </div>,
            document.body
          )
        : card
    }}
  </Draggable>
)
